import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiCheckCircle, FiSend, FiArrowRight, FiRefreshCw } from "react-icons/fi";

const Otherstate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve action state passed from Othercontract or fallback
  const actionType = location.state?.status || "submitted"; 
  const itemTitle = location.state?.itemTitle || "Item / Service";

  const handleGoHome = () => {
    navigate("/connect"); // Adjust path to your main home/dashboard route 
  }; 

  return (
    <div className="bg-gray-50 min-h-screen pb-12 flex flex-col justify-between">
      {/* 🔝 Sticky Header */}
      <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex items-center justify-center">
        <h1 className="text-lg font-black text-gray-900 tracking-tight">Contract Status</h1>
      </div>

      <div className="max-w-md mx-auto px-6 pt-12 flex-1 flex flex-col items-center text-center">
        
        {/* Status Icon & Banner */}
        {actionType === "submitted" ? (
          <div className="space-y-6 w-full">
            <div className="w-24 h-24 bg-green-100 text-green-600 rounded-[2.5rem] mx-auto flex items-center justify-center shadow-lg shadow-green-100 animate-bounce">
              <FiSend size={44} />
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl font-black text-gray-900 tracking-tight">Delivery Submitted!</h2>
              <p className="text-xs font-bold text-gray-500 leading-relaxed px-4">
                Thank you for completing and submitting the delivery for <span className="text-gray-900">{itemTitle}</span>. The buyer has been notified to verify.
              </p>
            </div>
          </div>
        ) : actionType === "rejected" ? (
          <div className="space-y-6 w-full">
            <div className="w-24 h-24 bg-orange-100 text-orange-600 rounded-[2.5rem] mx-auto flex items-center justify-center shadow-lg shadow-orange-100">
              <FiRefreshCw size={44} className="animate-spin" />
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl font-black text-gray-900 tracking-tight">Contract Sent Back for Review</h2>
              <p className="text-xs font-bold text-gray-500 leading-relaxed px-4">
                You have rejected the terms for <span className="text-gray-900">{itemTitle}</span>. Rest assured, the feedback has been sent back to the buyer to review and update the agreement.
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-6 w-full">
            <div className="w-24 h-24 bg-green-100 text-green-600 rounded-[2.5rem] mx-auto flex items-center justify-center shadow-lg shadow-green-100">
              <FiCheckCircle size={48} />
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl font-black text-gray-900 tracking-tight">Action Successful</h2>
              <p className="text-xs font-bold text-gray-500 leading-relaxed px-4">
                Your contract status update for <span className="text-gray-900">{itemTitle}</span> has been processed and logged successfully with OurASAP.
              </p>
            </div>
          </div>
        )}

        {/* Action Button: Go to Home */}
        <div className="w-full pt-10">
          <button
            type="button"
            onClick={handleGoHome}
            className="w-full py-5 bg-gray-900 hover:bg-black text-white rounded-[1.5rem] font-black uppercase tracking-[0.2em] text-xs transition-all shadow-xl shadow-gray-300 active:scale-95 flex items-center justify-center gap-3"
          >
            Go to Home
            <FiArrowRight size={16} />
          </button>
        </div>

      </div>

      <p className="text-center mt-10 text-[10px] font-black text-gray-300 uppercase tracking-widest">
        Secure Contracts • Instant Enforcement • OurASAP
      </p>
    </div>
  );
};

export default Otherstate;